<template>
  <div style="width: 100%;" class="video-js vjs-16-9 vjs-big-play-centered">
    <video
      ref="VideoJsPlayer"
      id="custom-rtmp-player"
      style="position:absolute;top:0;left:0;width:100%;height:100%;"
      class="vjs-default-skin"
      controls
    ></video>
  </div>
</template>

<script>
import videojs from "video.js";

export default {
  name: "VideoJsPlayer",
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      player: null
    };
  },
  mounted() {
    let $vm = this;
    $vm.player = videojs(this.$refs.VideoJsPlayer, this.options, () => {
      //$vm.player.log("onPlayerReady", this);
      $vm.player.muted(true);
      var promise = $vm.player.play();
      if (promise !== undefined) {
        promise.then(function() {
          // Autoplay started
          $vm.player.muted(false);
        });
      }
    });
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
};
</script>
